import { FaInfoCircle } from "react-icons/fa";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type Props = {
	totalMedicalAttendancesOnTime: number;
	totalMedicalAttendancesOutTime: number;
	totalMedicalAttendancesWithoutRiskClassification: number;
	totalPercentageEvasion: number;
};

export function SpecialtyOfficeCards({
	totalMedicalAttendancesOnTime,
	totalMedicalAttendancesOutTime,
	totalMedicalAttendancesWithoutRiskClassification,
	totalPercentageEvasion,
}: Props) {
	return (
		<Row className=" py-2 bg-white justify-content-evenly rounded">
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Atendimentos no tempo limite"
					value={totalMedicalAttendancesOnTime.toLocaleString()}
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Atendimentos acima do tempo limite"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					value={totalMedicalAttendancesOutTime.toLocaleString()}
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Atendimentos sem classificação"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={totalMedicalAttendancesWithoutRiskClassification.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="% de evasões no consultório"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={`${totalPercentageEvasion.toLocaleString()} %`}
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
		</Row>
	);
}
